import { generatePath } from "react-router";

const urls: { [x: string]: string } = {
  login: "/login",
  "reset-password": "/reset-password",
  "reset-set-password": "/reset/:token",
  activate: "/activate/:token",
  attendees_list: "/attendees",
  attendees_detail: "/attendees/:id",
  attendees_detail_evaluation: "/attendees/:id/evaluation",

  accounts_list: "/accounts",
  accounts_detail: "/accounts/:id",

  account_settings: "/account-settings",
  email_templates_edit: "/email-templates/:id",

  brand_settings_license_types: "/brand-settings/license-types",
  brand_settings_knowledge_modules: "/brand-settings/learning-modules",

  company_form_add: "/company-form",

  contacts_list: "/new-contacts",
  contacts_detail: "/new-contacts/:id",

  dashboard: "/dashboard",

  evaluation_form_edit: "/evaluation-form-configuration/:id/edit",
  evaluation_form_add: "/evaluation-form-configuration",
  events_list: "/brand-events",

  invoices_list: "/invoices",

  licensee_profile: "/licensee/:id",
  licensee_licenses: "/licensee/:id/licenses",
  licensee_access: "/licensee/:id/access",
  licensee_sublicenses: "/licensee/:id/sub-licenses",
  licensee_managers: "/licensee/:id/managers",
  licensee_managers_edit: "/licensee/:id/manager/:managerId/edit",
  licensee_managers_add: "/licensee/:id/manager/add",
  licensees_list: "/licensees",
  licensees_add_company: "/licensees/add-company",
  licensee_edit_company: "/licensees/edit-company/:id",

  license_agreement_edit: "/license-agreement/:licenseTypeId/edit/:id",
  license_agreement_add: "/license-agreement/:licenseTypeId",

  license_type_add: "/license-type/new",
  license_type_edit: "/license-type/:id",

  license_renewal_templates_edit: "/license-renewal-templates/:licenseTypeId",
  license_renewal_period_edit: "/license-renewal-period/:id",

  registration_form_configuration_edit:
    "/registration-form-configuration/:id/edit",
  registration_form_configuration_add: "/registration-form-configuration",

  participations_list: "/participations",
  participations_detail: "/participations/:id",

  // public routes
  public_evaluation_form: "/public/evaluation/:event_id/:attendee_id",
  public_evaluation_form_success:
    "/public/evaluation/:event_id/:attendee_id/success",
  public_evaluation_form_share:
    "/public/evaluation/:event_id/:attendee_id/share",

  "dev:index": "/f2/",
  "dev:test": "/f2/test/",
  "dev:settings": "/f2/settings/",
};

export function route(name: string) {
  if (!urls[name]) {
    throw `UnknownRoute("${name}")`;
  }

  return urls[name];
}

export function reverse(
  name: string,
  params: { [x: string]: string | number } | undefined = undefined
) {
  return generatePath(route(name), params);
}
